import { render, staticRenderFns } from "./scrum.vue?vue&type=template&id=2b98e32e&scoped=true"
import script from "./scrum.vue?vue&type=script&lang=js"
export * from "./scrum.vue?vue&type=script&lang=js"
import style0 from "./scrum.vue?vue&type=style&index=0&id=2b98e32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b98e32e",
  null
  
)

export default component.exports